<ion-header mode="ios" class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content scrollY="false">
  <div class="youtube-container" [ngClass]="{supported: liked}">
    <iframe class="responsive-video" [src]="safeURL" frameborder="0" allowfullscreen="false"></iframe>
  </div>

  <div class="button-holder" *ngIf="!liked">
    <button (click)="openCampaignSupport()" class="support-button">{{'IMPACT.publicisCampaign.button.support' | translate}}</button>
  </div>
</ion-content>
